<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     标签面板
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="make-tag">
    <el-dialog
      width="600px"
      class="make-tag-dialog"
      :title="`「${title}」打标签`"
      :visible.sync="dialogShow"
      :modal-append-to-body="false"
      :append-to-body="true"
      @closed="onClosed">
      <div v-loading="loading" class="pl" style="min-height: 200px;">
        <el-checkbox-group v-model="checkedTagids">
          <el-checkbox v-for="item in list" :key="item.tagid" :label="item.tagid" class="tag-checkbox">{{ item.title }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="flex-center mb">
        <el-button class="extend" @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getallApi, fetchApi, setApi } from "@/api/fam/famTagApi";
export default {
  name: "MakeTag",

  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "equip"
    },

    uniqueKey: {
      type: Number,
      default: 0
    },

    title: {
      type: String,
      default: ""
    },

    tags: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      loading: false,
      list: [],
      checkedTagids: []
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  },
  created() {
    this.fetchData();
  },

  methods: {
    onClosed() {
      this.list = [];
      this.checkedTagids = [];
    },

    fetchData() {
      this.loading = true;
      getallApi({ type: this.type }).then(res => {
        if (!res.errno) {
          this.list = res.data.list;
          fetchApi({ type: this.type, unique_key: this.uniqueKey }).then(
            res2 => {
              this.loading = false;
              if (!res2.errno) {
                this.checkedTagids = res2.data.list.map(v => v.tagid);
              }
            }
          );
        }
      });
    },

    submit() {
      setApi({
        type: this.type,
        unique_key: this.uniqueKey,
        tagids: this.checkedTagids
      }).then(res => {
        if (res.errno === 0) {
          this.$message.success("操作成功！");
          this.dialogShow = false;
          this.$emit("update");
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.make-tag {
  display: inline-block;
  .new-btn {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
/deep/ .tag.el-tag--blue {
  border: none;
}
</style>

<style lang="scss">
.make-tag-dialog {
  .tag-checkbox {
    min-width: 120px;
    margin-right: 15px;
    margin-bottom: 15px;
  }
}
</style>
